import * as React from 'react'
import Helmet from 'react-helmet'

import { StoreViewWithState, useActiveStoreView } from '@emico/storeviews'

import { useProductMeta } from '../actions/storeView/GetProductMeta.query'

interface Props {
    storeView: StoreViewWithState
    urlId: number
}

const ProductCanonical = ({ storeView, urlId }: Props) => {
    const activeStoreView = useActiveStoreView()
    const { loading, data } = useProductMeta(urlId)

    if (loading) {
        return null
    }
    if (!data || !data.product) {
        return null
    }

    const { urlKey } = data.product
    const href = storeView.makeUrl(`/${urlKey}`)

    return (
        <Helmet>
            <link rel="alternate" href={href} hrefLang={storeView.hrefLang} />
            {storeView.hrefLang === 'x-default' && (
                <link
                    rel="alternate"
                    href={href}
                    hrefLang={storeView.locale || storeView.language}
                />
            )}
            {activeStoreView === storeView && (
                <link rel="canonical" href={href} />
            )}
        </Helmet>
    )
}

export default ProductCanonical
